import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import LogRocket from 'logrocket';
import {Provider} from 'react-redux';

import App from './App';
import store from './redux/store';
import './index.css';

if (window.cheffdomrelease) {
    LogRocket.init(window.cheffdomlogrocket ? window.cheffdomlogrocket : 'xslgsi/cheffdom');
    LogRocket.getSessionURL(sessionURL => {
        console.log(sessionURL);
    });
    LogRocket.track(window.location.host);
}

console.log(`Screen: ${window.screen.width}x${window.screen.height}`);


ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App/>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
